export const TOGGLE_MENU = 'SYSTEM/TOGGLE_MENU';

export function toggleMenu() {
  return {
    type: TOGGLE_MENU
  } as const;
}

export type SystemActionTypes = ReturnType<typeof toggleMenu>;
